import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export const trackAmplitudeAiSignModalView = (modalSize: AmplitudeSemanticSearchModalSize | null, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("ai_sign_modal_view", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null,
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

export const trackAmplitudeAiSignModalView = (modalSize: AmplitudeSemanticSearchModalSize | null, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("ai_sign_modal_view", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null,
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION
    });
};
